<template>
  <div v-if="transaction">
    <user-details :data-user="transaction.source_user" title="Sender" hide-actions />

    <individual-bank-details
      class="mt-5"
      v-if="transaction.payment.type == 'bank_transfer'"
      :payment="transaction.payment"
      :transaction="transaction"
      :owner="transaction.source_user"
    />

    <transfer-details
      :dataTransaction.sync="transaction"
      @reloadTransfer="refetchTransfer"
      class="mt-5"
    />
    <transfer-documents
      :uploadUrl="uploadUrl"
      :data-documents="transaction.documents"
      title="Upload Bulk Transfer Documents"
      :extraFields="{ type: 'bulk-transfer' }"
      class="mt-3"
    />
    <RecipientsDetails :transaction="transaction" />
    <blockchain-transaction :transaction="transaction" />
  </div>
</template>
<script>
import UserDetails from "@/app/users/detail";
import IndividualBankDetails from "@/app/accounts/bankaccounts/IndividualBankDetails";
import TransferDetails from "./details";
import BlockchainTransaction from "./blockchaintransactions.vue";
import RecipientsDetails from "./transferRecipients.vue";
import TransferDocuments from "./documents/index.vue";
export default {
  components: {
    UserDetails,
    TransferDetails,
    IndividualBankDetails,
    BlockchainTransaction,
    RecipientsDetails,
    TransferDocuments,
  },
  props: {
    id: {
      required: true,
    },
  },
  data: () => ({ transaction: undefined }),
  created() {
    this.fetchData();
  },
  computed: {
    uploadUrl() {
      return `api/v1/transfers/${this.transaction.payment.id}/documents`;
    },
  },
  methods: {
    async fetchData() {
      await this.$http.get(`/api/v1/transactions/bulkTransfers/${this.id}`).then((data) => {
        this.transaction = data;
      });
    },
    refetchTransfer() {
      this.fetchData();
    },
  },
};
</script>
